<template>
  <div>
    <b-modal :active.sync="isModalActive"
      has-modal-card full-screen :can-cancel="false">
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
        <pdf-viewer :title="text" :url="lesson.url" v-if="!isLoading  &&  lesson"/>
    </b-modal>
  </div>
</template>

<script>
import PdfViewer from '@/components/PDFViewer'
import LessonService from '@/services/LessonService.js'

export default {
  components: {
    PdfViewer
  },
  props: {
    lessonId: {
      required: false,
      type: Number
    },
    text: {
      required: false,
      type: String,
      default: 'Lección'
    },
    active: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      isLoading: false,
      isModalActive: this.active,
      lesson: null
    }
  },
  methods: {
    async getLesson () {
      if (this.lessonId) {
        this.isLoading = true
        this.isModalActive = true
        let response = await LessonService.getLesson(this.lessonId)
        this.lesson = response.data.data
        this.isLoading = false
      }
    }
  },
  watch: {
    active () {
      if (this.active === true) {
        this.getLesson()
      }
      if (this.active !== this.isModalActive) {
        this.isModalActive = this.active
      }
    },
    isModalActive () {
      if (this.isModalActive !== this.active) {
        this.$emit('update:active', this.isModalActive)
      }
    }
  }
}
</script>
